export default "__VITE_ASSET__CKhz6VO___"